<template>
	<div class="col-sm-12 navigator">
		<div class="row w-100">
			<div class="col-md-6">
				<div class="row">
					<span class="clickToOpen ml-2 px-2 pointer" @click="toggleReportList()">
						<span class="fs-largest darkset">{{selectedAvaliableReport.label}}</span>
						<i class="color-1 large ml-4 pl-2" :class="{'ico-arrow-bottom': !showReportSelector, 'ico-arrow-top': showReportSelector}"></i>
						
						<ul class="selectDrawer bg-lightest p-2 border-medium w-100 radius-normal mt-2" v-if="showReportSelector">
							<li v-for="option in avaliableReports" class="fs-larger py-1" @click="selectReport(option)">{{option.label}}</li>
						</ul>
					</span>
				</div>
			</div>

			<div class="col-md-6">
				<div class="row justify-content-end dark fs-largest">
					{{ dateFrom | moment('D MMMM YYYY') }} - {{ dateTo | moment('D MMMM YYYY') }}
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		mounted() {
			// Set starting selected report
			this.selectedAvaliableReport = this.avaliableReports[0];
		},
		data() {
			return {
				showReportSelector: false,
				selectedAvaliableReport: {},
			}
		},
		methods:{
			toggleReportList() {
				this.showReportSelector = !this.showReportSelector;
			},
			selectReport(selectedReport) {
				this.selectedAvaliableReport = selectedReport;
			}
		},
		props: [
			'avaliableReports',
			'dateFrom',
			'dateTo'
		]
	}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// Navigator.vue?6c8419e7